{
  "version": "v4.0.0",
  "name": "TestToken",
  "bytecode": "050509121b40244035010000000102ce0002010000000102ce0102010000000102ce0202010000000102ce0302010202020005d359e9ded71600b11601ab",
  "codeHash": "f9dac4e7d0bf28a2bc019f43138339e23afadde322d50441cdfe029993bf35f3",
  "fieldsSig": {
    "names": [
      "symbol",
      "name",
      "decimals",
      "totalSupply",
      "__stdInterfaceId"
    ],
    "types": [
      "ByteVec",
      "ByteVec",
      "U256",
      "U256",
      "ByteVec"
    ],
    "isMutable": [
      false,
      false,
      false,
      false,
      false
    ]
  },
  "eventsSig": [],
  "functions": [
    {
      "name": "getSymbol",
      "paramNames": [],
      "paramTypes": [],
      "paramIsMutable": [],
      "returnTypes": [
        "ByteVec"
      ]
    },
    {
      "name": "getName",
      "paramNames": [],
      "paramTypes": [],
      "paramIsMutable": [],
      "returnTypes": [
        "ByteVec"
      ]
    },
    {
      "name": "getDecimals",
      "paramNames": [],
      "paramTypes": [],
      "paramIsMutable": [],
      "returnTypes": [
        "U256"
      ]
    },
    {
      "name": "getTotalSupply",
      "paramNames": [],
      "paramTypes": [],
      "paramIsMutable": [],
      "returnTypes": [
        "U256"
      ]
    },
    {
      "name": "getToken",
      "paramNames": [
        "sender",
        "amount"
      ],
      "paramTypes": [
        "Address",
        "U256"
      ],
      "paramIsMutable": [
        false,
        false
      ],
      "returnTypes": []
    }
  ],
  "constants": [],
  "enums": [],
  "stdInterfaceId": "0001"
}